








































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import { getAssetType } from '@/services/assets'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { EVMTransactionResponse } from '@/store/modules/transactions/models'
import { AVAX_ID } from '@/known_assets'

@Component({
    components: {
        Tooltip,
    },

    filters: {
        getType: getMappingForType,
        getAssetType,
    },
})
export default class EVMMetadata extends Vue {
    @Prop() tx!: EVMTransactionResponse

    get assetsLoaded(): boolean {
        return this.$store.state.assetsLoaded
    }

    get nativeSymbol() {
        return this.$store.state.assets[AVAX_ID].symbol
    }
}
